module.exports = __webpack_public_path__ + "static/img/logo_1.ce1770d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_1.png
// module id = 0QkM
// module chunks = 1